export const preprocessData = data => {
    const dateCount = {};

    data.forEach(item => {
        const date = item.created_at.split(' ')[0];
        dateCount[date] = (dateCount[date] || 0) + 1; // Увеличиваем счетчик для этой даты
    });

    return {
        dates: Object.keys(dateCount),
        counts: Object.values(dateCount),
    };
};
